export default {"src":"/_next/static/image/public/logos/gitlab.2cf8224cd40e2804826b5b979af03522.svg","height":311,"width":338};